module.exports = __webpack_public_path__ + "static/media/github-cli-screenshot.43fec6e2.png";